import { ISelectOption } from '../../../ui-toolkit';

export enum eACHDisbursementCategories {
  Borrower = 'borrower',
  Lender = 'lender',
  Seller = 'seller',
  ThirdParty = 'third_party',
}

export const prettyACHDisbursementCategory: Record<eACHDisbursementCategories, string> = {
  [eACHDisbursementCategories.Borrower]: 'Borrower',
  [eACHDisbursementCategories.Lender]: 'Lender',
  [eACHDisbursementCategories.Seller]: 'Seller',
  [eACHDisbursementCategories.ThirdParty]: 'Third Party',
};

export const achDisbursementCategoriesOptions: ISelectOption[] = Object.values(eACHDisbursementCategories).map(
  (category) => ({
    label: prettyACHDisbursementCategory[category],
    value: category,
  })
);
